import { cn } from '@/shared/utils/formatting';

interface HeroAtmosphereProps {
  className?: string;
}

export function HeroAtmosphere({ className }: HeroAtmosphereProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('absolute inset-0 pointer-events-none', className)}
      style={{
        background: [
          'radial-gradient(60% 50% at 65% 42%, rgba(171, 0, 19, 0.22) 0%, rgba(171, 0, 19, 0.08) 30%, rgba(171, 0, 19, 0) 62%)',
          'radial-gradient(80% 60% at 15% 90%, rgba(40, 8, 16, 0.6) 0%, rgba(0, 0, 0, 0) 60%)',
          'radial-gradient(60% 50% at 100% 0%, rgba(30, 10, 20, 0.8) 0%, rgba(0, 0, 0, 0) 60%)',
        ].join(', '),
      }}
    />
  );
}
